export const PRODUCT_MONTHS = {
  THREE: 3,
  SIX: 6,
};

export const LINKS = {
  SAVVY_WHATSAPP: 'https://wa.me/919136099947',
  TERM_AND_CONDITIONS: 'https://www.savvyapp.in/terms-and-conditions',
  PRIVACY_POLICY: 'https://www.savvyapp.in/privacy-policy',
  LINKEDIN: 'https://www.linkedin.com/company/savvyapp/?originalSubdomain=in',
  INSTA: 'https://www.instagram.com/savvyapp.in/?hl=en',
  FACEBOOK: 'https://www.facebook.com/SavvyPay.in/',
  EMAIL: 'hello@savvyapp.in',
  SHOP_SAVVY: 'https://shop.savvyapp.in',
  SURVEY_LINK:
    'https://savvyapp.surveysparrow.com/n/Savvyapp-NPS/ntt-9949b2?email=user@somecompany.com',
};
